import { render, staticRenderFns } from "./ProdutionList.vue?vue&type=template&id=1700c5d7&scoped=true&"
import script from "./ProdutionList.vue?vue&type=script&lang=ts&"
export * from "./ProdutionList.vue?vue&type=script&lang=ts&"
import style0 from "./ProdutionList.vue?vue&type=style&index=0&id=1700c5d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1700c5d7",
  null
  
)

export default component.exports